const getClusterIconSVG = (count) => `
<svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76">
  <defs>
    <filter id="shadow" x="0" y="0" width="76" height="76">
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="2" />
      <feColorMatrix type="matrix"
        values="0 0 0 0 0
                0 0 0 0 0
                0 0 0 0 0
                0 0 0 .25 0"/>
      <feBlend in="SourceGraphic"/>
    </filter>

    <linearGradient id="bg" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#D74166"/>
      <stop offset="100%" stop-color="#EE789F"/>
    </linearGradient>
  </defs>

  <!-- Background -->
  <circle cx="38" cy="38" r="34" fill="url(#bg)" filter="url(#shadow)"/>

  <!-- Centered content -->
  <g transform="translate(38 38)">
    
    <!-- Icon -->
    <svg x="-7" y="-16" width="14" height="14" viewBox="0 0 14 14" fill="transparent" stroke="white" stroke-width="1">
      <path d="M3.11 13.93H0V5.02L3.11 1.91Z"/>
      <path d="M5.8 13.93H2.76V0L5.8 2.19Z"/>
      <path d="M8.56 13.93H5.44V7.64L8.56 5.52Z"/>
      <path d="M11.24 13.93H8.13V2.97L9.69 1.98L11.24 2.97Z"/>
      <path d="M14 13.93H10.96V3.89L14 6.01Z"/>
    </svg>

    <!-- Count -->
    <text
      y="14"
      fill="white"
      font-size="16"
      font-weight="700"
      text-anchor="middle"
      dominant-baseline="middle"
      font-family="Inter, Arial, sans-serif"
    >
      ${count}
    </text>
  </g>
</svg>
`;

export default getClusterIconSVG;
{
  /* <svg
  xmlns="http://www.w3.org/2000/svg"
  width="${size}"
  height="${size}"
  viewBox="0 0 100 100"
>
  <circle cx="50" cy="50" r="42" fill="${fill}" fill-opacity="0.95" />
  <text
    x="50"
    y="62"
    text-anchor="middle"
    font-family="Arial, sans-serif"
    font-size="34"
    font-weight="700"
    fill="white"
  >
    ${count}
  </text>
</svg>; */
}
